// API Utility for authenticated requests
// This ensures all API calls include the JWT token

import { PRODUCTION_URL } from '../pages/productionLink/productionLink';

const API_BASE_URL = `${PRODUCTION_URL}/api`;

/**
 * Makes an authenticated API request
 * @param {string} endpoint - API endpoint (e.g., '/admin/stats')
 * @param {object} options - Fetch options (method, body, etc.)
 * @returns {Promise} - Response data
 */
export const apiCall = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token');

    if (!token) {
        throw new Error('No authentication token found');
    }

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers
    };

    const config = {
        ...options,
        headers
    };

    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

    // Handle 401 Unauthorized - redirect to login
    if (response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        throw new Error('Session expired. Please login again.');
    }

    const data = await response.json();
    return data;
};

/**
 * GET request helper
 */
export const apiGet = async (endpoint) => {
    return apiCall(endpoint, { method: 'GET' });
};

/**
 * POST request helper
 */
export const apiPost = async (endpoint, body) => {
    return apiCall(endpoint, {
        method: 'POST',
        body: JSON.stringify(body)
    });
};

/**
 * PUT request helper
 */
export const apiPut = async (endpoint, body) => {
    return apiCall(endpoint, {
        method: 'PUT',
        body: JSON.stringify(body)
    });
};

/**
 * DELETE request helper
 */
export const apiDelete = async (endpoint) => {
    return apiCall(endpoint, { method: 'DELETE' });
};

export default apiCall;
